import { Environment } from '@/react/portainer/environments/types';
import { useIsEdgeAdmin } from '@/react/hooks/useUser';
import { useFIPSMode } from '@/react/portainer/settings/queries/useFIPSMode';

import { isKubeSoloEnvironment } from './isKubeSoloEnvironment';

/** Whether to link to the environment's KubeSolo page: KubeSolo's API is root on the machine, and Portainer has no KubeSolo in FIPS mode. */
export function useShowKubeSolo(environment?: Environment) {
  const { isAdmin } = useIsEdgeAdmin({ forceEnvironmentId: environment?.Id });
  const isFIPSMode = useFIPSMode();

  return isAdmin && !isFIPSMode && isKubeSoloEnvironment(environment);
}
